import { __rest } from "tslib";
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { BaseForm } from 'uniforms';
const Bootstrap4 = (parent) => {
    class _ extends parent {
        getChildContextState() {
            return Object.assign(Object.assign({}, super.getChildContextState()), { grid: this.props.grid });
        }
        getNativeFormProps() {
            const error = this.getChildContextError();
            const _a = super.getNativeFormProps(), { className, grid } = _a, // eslint-disable-line no-unused-vars
            props = __rest(_a, ["className", "grid"]);
            return Object.assign(Object.assign({}, props), { className: classnames('form', { error }, className) });
        }
    }
    _.Bootstrap4 = Bootstrap4;
    _.displayName = `Bootstrap4${parent.displayName}`;
    _.propTypes = Object.assign(Object.assign({}, parent.propTypes), { grid: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.object,
            PropTypes.string,
        ]) });
    return _;
};
export default Bootstrap4(BaseForm);
